export default {
    process_track_id: null,
    steps: [],
}